import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { normalizeRole } from '../lib/rbac'

const useManagerStore = create(
  persist(
    (set) => ({
      tenantId: null,
      tenantName: null,
      branchId: null,
      role: 'admin',
      creditStatus: null,
      conversations: [],
      bookings: [],
      customers: [],
      tenant: null,
      setTenant: (tenant) => set({ tenant }),
      setProfileContext: ({ role, tenantName }) =>
        set((state) => ({
          role: role ? normalizeRole(role) : state.role,
          tenantName: tenantName ?? state.tenantName,
        })),
      setBranchRole: (role) =>
        set({ role: normalizeRole(role) }),
      setActiveBranchContext: ({ tenantId, tenantName, branchId }) =>
        set({
          tenantId: tenantId ?? null,
          tenantName: tenantName ?? null,
          branchId: branchId ?? null,
          creditStatus: null,
        }),
      clearActiveBranchContext: () =>
        set({ tenantId: null, tenantName: null, branchId: null, creditStatus: null }),
      setCreditStatus: (creditStatus) => set({ creditStatus }),
      setConversations: (conversations) => set({ conversations }),
      setBookings: (bookings) => set({ bookings }),
      setCustomers: (customers) => set({ customers }),
      clearManager: () =>
        set({
          tenantId: null,
          tenantName: null,
          branchId: null,
          role: 'admin',
          creditStatus: null,
          conversations: [],
          bookings: [],
          customers: [],
          tenant: null,
        }),
    }),
    {
      name: 'growchat_manager',
      partialize: (s) => ({
        tenantId: s.tenantId,
        tenantName: s.tenantName,
        branchId: s.branchId,
        role: s.role,
        tenant: s.tenant,
      }),
    }
  )
)

export default useManagerStore
